// src/api/client.js
import axios from 'axios';
import { clearAuthTokens, getAccessToken, refreshAccessToken } from 'api/authTokens';

const API_BASE_URL =
  import.meta.env.VITE_APP_API_BASE_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Attach Authorization header if token exists
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 globally: refresh once, then redirect if refresh fails.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config || {};
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      !String(originalRequest.url || '').includes('/api/auth/token/')
    ) {
      originalRequest._retry = true;
      const nextToken = await refreshAccessToken();
      if (nextToken) {
        originalRequest.headers = {
          ...(originalRequest.headers || {}),
          Authorization: `Bearer ${nextToken}`
        };
        return api(originalRequest);
      }
    }
    if (error.response && error.response.status === 401) {
      clearAuthTokens();
      window.location.href = '/auth/login';
      return;
    }
    return Promise.reject(error);
  }
);

export default api;
